import $ from "jquery";
var actions = {
  preventScroll: function (shouldPrevent) {
    // This is gross, I know. We need to make sure the body can't scroll behind
    // the modal because ReactModal has a bug where the modal-open body class is
    // not properly appended when the modal is open
    const modalOpenClass = "FilterModalBody--open";
    $("body").toggleClass(modalOpenClass, shouldPrevent);
  },

  // After close a modal were some filters changed
  // sometimes we need to move the scroll of the
  // window to the top position
  scrollToPosition: function (position) {
    if (window?.requestAnimationFrame) {
      window.requestAnimationFrame(() => {
        window.scrollTo(0, position);
      });
    }
  },
};

export default actions;

export const { preventScroll, scrollToPosition } = actions;
